
import { BookingsOrdersApiMethods } from "./methods";
import { execute } from "../../apiCommandsExecutor";
import { ExecutionStatus } from "../general/requestsResponses";
import {
    BookingOrdersUpdateBookingOrderStatusRequest, BookingOrdersUpdateBookingOrderStatusResponse,
    ICancelBookingOrderPaymentRequest, ICancelBookingOrderPaymentResponse,
    ICreateBookingOrderRequest,
    ICreateBookingOrderResponse, IGetBookingOrderRequest, IGetBookingOrderResponse,
    IGetBookingOrdersRequest,
    IGetBookingOrdersResponse, IGetBookingsRequest, IGetBookingsResponse
} from "./requestsResponses";


export const getBookingOrders = async (params: IGetBookingOrdersRequest) => {
    const response = await execute<IGetBookingOrdersRequest, IGetBookingOrdersResponse>(
        BookingsOrdersApiMethods.getBookingOrders,
        params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        orders: response.data.bookingOrders
    }
};
export const getBookingOrder = async (params: IGetBookingOrderRequest) => {
    const response = await execute<IGetBookingOrderRequest, IGetBookingOrderResponse>(
        BookingsOrdersApiMethods.getBookingOrder,
        params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        order: response.data.bookingOrder
    }
};

export const createBookingOrder = async (params: ICreateBookingOrderRequest) => {
    const response = await execute<ICreateBookingOrderRequest, ICreateBookingOrderResponse>(
        BookingsOrdersApiMethods.createBookingOrder,
        params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        orders: response.data.orderId
    }
};


export const cancelBookingOrder = async (params: ICancelBookingOrderPaymentRequest) => {
    const response = await execute<ICancelBookingOrderPaymentRequest, ICancelBookingOrderPaymentResponse>(
        BookingsOrdersApiMethods.ordersCancelOrderPayment,
        params);
    return response.data
};



export const getBookings = async (params: IGetBookingsRequest) => {
    const response = await execute<IGetBookingsRequest, IGetBookingsResponse>(
        BookingsOrdersApiMethods.getBookings,
        params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        bookings: response.data.bookings
    }
};

export const updateBookingOrderStatus = async (params:  BookingOrdersUpdateBookingOrderStatusRequest) => {
    const response = await execute< BookingOrdersUpdateBookingOrderStatusRequest,  BookingOrdersUpdateBookingOrderStatusResponse>(
        BookingsOrdersApiMethods.updateBookingOrderStatus,
        params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
    }
};
